import { render, staticRenderFns } from "./changetelPage.vue?vue&type=template&id=288db651&scoped=true"
import script from "./changetelPage.vue?vue&type=script&lang=js"
export * from "./changetelPage.vue?vue&type=script&lang=js"
import style0 from "./changetelPage.vue?vue&type=style&index=0&id=288db651&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288db651",
  null
  
)

export default component.exports